import { StorageKeys } from "@/config/consts";
import { Api, TokenApi } from "@/services/api.service";
import { ApiCatch, Catch } from "@/utils/decorators";
import { AuthModule } from "@/store/auth.module";
import router from "@/router";

export class AuthService {
  @Catch(e => ({
    result: e?.response?.data.message,
  }))
  public static async signInLogin(
    login: string,
    password: string,
    recaptchaToken: string,
  ): Promise<MessageValue<boolean>> {
    const response = await Api.post(
      "/auth/signin_login",
      {
        login,
        password,
      },
      { params: { recaptchaToken } },
    );

    const token = response.data.accessToken;
    AuthService.setToken(token);

    return { result: true };
  }

  /**
   * Checks local token for existence
   */
  public static hasToken(): boolean {
    const token = this.getToken();
    return token != null;
  }

  public static setToken(token: string): void {
    localStorage.setItem(StorageKeys.TOKEN, token);
    AuthModule.setIsLoggedIn(true);
  }

  public static getToken(): string | null {
    return localStorage.getItem(StorageKeys.TOKEN);
  }

  /**
   * @description Refreshes local token
   */
  @ApiCatch
  public static async refreshToken() {
    const localToken = AuthService.getToken();
    // if there's no local token, do not try refreshing it
    if (!localToken) return { status: 400 };
    const response = await TokenApi.post("/auth/refreshToken");

    const token = response.data.accessToken;
    AuthService.setToken(token);

    return response;
  }

  /**
   * @description Logout the user, removes all
   * local data, and forwards router to the auth page
   */
  public static async logout(needRedirect: boolean = true) {
    AuthModule.setUser(null as any);
    AuthModule.setIsLoggedIn(false);
    localStorage.removeItem(StorageKeys.TOKEN);
    if (needRedirect) {
      router.push({ name: "auth" });
    }
  }

  /**
   * @description Fetches the user info
   */
  @ApiCatch
  public static async getUser() {
    return Api.get("/auth/user");
  }
}
